import { Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../theme/helpers/fontStyle';

export const $CloseModalBlock = styled.div`
  position: absolute;
  top: ${spacing('lg')};
  right: ${spacing('lg')};
  line-height: 12px;
  outline: none;
  cursor: pointer;
`;

export const $ConfirmCancelModalRow = styled(Row)`
  ${fontStyle('base')};
  padding: ${spacing(2.5)} 0 ${spacing('xxl')};
`;
